module.exports = __webpack_public_path__ + "img/9788972978824.acc7afdc.jpg";